import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import {
  newNextAction,
  manualPaymentAction,
  NEW_NEXT,
  MANUAL_PAYMENT,
} from '../../actions/navigation';
import Modal from '../../components/Modal';
import Button from '../../components/Button';
import Progress from '../../components/Progress';
import FormRow from '../../components/Form/FormRow';
import FormColumn from '../../components/Form/FormColumn';

import { useConfig } from '../../config/ConfigContext';

const Check = (props) => {
  const config = useConfig();
  const { checkinData, navigate, params, searchParams, dispatch } = props;
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [uploadingPercentage, setUploadingPercentage] = useState(false);
  const workflowType = get(params, 'workflowType');
  const key = searchParams.get('key');

  useEffect(() => {
    if (get(checkinData, ['data', 'data']) === undefined) {
      navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}`);
    }
  }, []);

  useEffect(() => {
    const { fetch } = props;

    if ((fetch.isDone[`${NEW_NEXT}`] && !fetch.isRunning[`${NEW_NEXT}`]) || (fetch.isDone[`${MANUAL_PAYMENT}`] && !fetch.isRunning[`${MANUAL_PAYMENT}`])) {
      const routeUrl = checkinData.data && checkinData.data.url.replace(config.hostUrl, '');
      navigate(`${routeUrl}`);
    }
  }, [checkinData]);

  const handleButtonClick = () => {
    setIsProgressVisible(true);

    dispatch(newNextAction({
      key,
      workflowType: workflowType || 'text2apply',
      onUploadProgress: (progressEvent) => {
        setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
      },
    }));
  };

  const handleBack = (e) => {
    e.preventDefault();
    setIsProgressVisible(true);
    dispatch(manualPaymentAction({
      key,
      workflowType: workflowType || 'text2apply',
      data: {},
    }));
  };

  return (
    <div>
      <Modal className="connect-bank">
        <div className="card-header">
          <button className="btn-back" type="button" onClick={handleBack}>Back</button>
          <h5>Pay By Check</h5>
        </div>
        <div className="card-content">
          <p><strong>Write and mail your check to:</strong></p>
          <p>
            LendingUSA
            <br />
            Attn: Payments Box 206536
            <br />
            Dallas TX, 75320-6536
          </p>
          <FormRow>
            <FormColumn>
              <Button
                onClick={handleButtonClick}
                className="btn btn-primary arrow"
                title="Confirm Pay By Check"
              />
            </FormColumn>
          </FormRow>
        </div>
      </Modal>
      {
        isProgressVisible && <Progress percent={uploadingPercentage} />
      }
    </div>
  );
};

Check.propTypes = {
  navigate: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  fetch: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(Check);
